import React from 'react';
import { useNavigate } from 'react-router-dom';

const StripeCancel = () => {
  const navigate = useNavigate();

  return (
    <div id="stripe-cancel-page" style={styles.page}>
      <div style={styles.card}>
        {/* Icono de cancelación */}
        <div style={styles.cancelIcon}>
          <div style={styles.cancelCircle}>
            <span style={styles.cancelMark}>✗</span>
          </div>
        </div>

        <h1 style={styles.title}>Pago Cancelado</h1>
        <p style={styles.subtitle}>
          El proceso de pago fue cancelado o no se pudo completar. No se ha realizado ningún cargo a tu cuenta.
        </p>

        <div style={styles.infoBox}>
          <div style={styles.infoStep}>
            <span style={styles.stepIcon}>❓</span>
            <div>
              <p style={styles.stepTitle}>¿Qué sucedió?</p>
              <p style={styles.stepDesc}>
                Es posible que hayas cerrado la ventana de pago, cancelado la transacción manualmente, 
                o que tu banco haya rechazado la tarjeta.
              </p>
            </div>
          </div>
          <div style={styles.infoStep}>
            <span style={styles.stepIcon}>🔄</span>
            <div>
              <p style={styles.stepTitle}>¿Qué puedes hacer?</p>
              <p style={styles.stepDesc}>
                Puedes intentar de nuevo el proceso de pago, seleccionar un plan diferente o usar otro 
                método de pago.
              </p>
            </div>
          </div>
        </div>

        <div style={styles.btnGroup}>
          <button
            id="btn-retry-payment"
            onClick={() => navigate('/stripe-checkout')}
            style={styles.primaryBtn}
          >
            🔄 Intentar de nuevo
          </button>
          <button
            id="btn-go-home"
            onClick={() => navigate('/')}
            style={styles.secondaryBtn}
          >
            Ir al Inicio
          </button>
        </div>

        <p style={styles.supportNote}>
          ¿Tienes dudas o problemas con tu tarjeta?{' '}
          <a
            href="https://wa.me/2296847814"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            Contáctanos por WhatsApp
          </a>
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0a1a2a 0%, #0f2035 50%, #0a1a2a 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    fontFamily: 'var(--font-primary)',
  },
  card: {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '24px',
    padding: '3rem 2.5rem',
    maxWidth: '560px',
    width: '100%',
    textAlign: 'center',
    backdropFilter: 'blur(10px)',
  },
  cancelIcon: {
    marginBottom: '1.5rem',
  },
  cancelCircle: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #ff5252 0%, #d32f2f 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    boxShadow: '0 0 30px rgba(255, 82, 82, 0.4)',
  },
  cancelMark: {
    fontSize: '2.5rem',
    color: 'white',
    fontWeight: '800',
    lineHeight: 1,
  },
  title: {
    fontSize: '2rem',
    fontWeight: '800',
    background: 'linear-gradient(90deg, #ff5252 0%, #ff8a8a 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    margin: '0 0 0.75rem 0',
  },
  subtitle: {
    color: 'var(--text-secondary)',
    fontSize: '1rem',
    marginBottom: '2rem',
    lineHeight: '1.6',
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginBottom: '2rem',
    textAlign: 'left',
  },
  infoStep: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'flex-start',
    background: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '12px',
    padding: '1rem',
    border: '1px solid rgba(255, 255, 255, 0.06)',
  },
  stepIcon: {
    fontSize: '1.5rem',
    flexShrink: 0,
  },
  stepTitle: {
    color: '#f5f5f5',
    fontWeight: '600',
    margin: '0 0 4px 0',
    fontSize: '0.9rem',
  },
  stepDesc: {
    color: 'var(--text-secondary)',
    fontSize: '0.82rem',
    margin: 0,
    lineHeight: '1.5',
  },
  btnGroup: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '1.5rem',
  },
  primaryBtn: {
    flex: 1,
    background: 'linear-gradient(135deg, #c5a059 0%, #dbb96a 100%)',
    border: 'none',
    padding: '13px 20px',
    color: '#0a1a2a',
    borderRadius: '10px',
    fontSize: '0.95rem',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'transform 0.2s',
  },
  secondaryBtn: {
    flex: 1,
    background: 'transparent',
    border: '1.5px solid rgba(255, 255, 255, 0.2)',
    padding: '13px 20px',
    color: 'var(--text-secondary)',
    borderRadius: '10px',
    fontSize: '0.95rem',
    cursor: 'pointer',
  },
  supportNote: {
    color: 'var(--text-muted)',
    fontSize: '0.8rem',
    marginTop: '1.5rem',
  },
  link: {
    color: '#dbb96a',
    textDecoration: 'none',
  },
};

export default StripeCancel;
